import React, { Fragment, PureComponent } from 'react';
import { getBrands, hasBrands } from '../../../../core/util/location';
import { BASE_URL } from '../../../../config';
import { BRAND_PATH } from '../../../../constants';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../constants/text';
import { colors } from '../../../../constants/colors';
import { biggerThanOrEqualTo } from '../../../../core/util/styledComponents';
import { isNativeApp } from '../../../../core/util/device';

const Root = styled.div`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueMonday};
  line-height: 21px;
  margin-top: 20px;
  ${biggerThanOrEqualTo.sm`
    margin-left: 125px;
    margin-top: 20px;
  `}
`;

class BrandAffiliation extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    userAgent: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.brands = getBrands(props.location);
  }

  getAffiliationName = brand => {
    const { userAgent } = this.props;

    if (isNativeApp(userAgent)) {
      return <span>{brand.title}</span>;
    }

    return (
      <a href={`${BASE_URL}${BRAND_PATH}/${brand.slug}`} alt={`${brand.title}`}>
        {brand.title}
      </a>
    );
  };

  render() {
    const { location } = this.props;
    if (!hasBrands(location)) return null;
    return (
      <Root>
        Affiliated with{' '}
        {this.brands.map((brand, index) => (
          <Fragment key={index}>
            {index !== 0 && <span>, </span>}
            {this.getAffiliationName(brand)}
          </Fragment>
        ))}
      </Root>
    );
  }
}

export default BrandAffiliation;
